import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { useRoot } from 'context/RootContext';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS, HTTP_VERBS } from 'utils/constants';

const path = id => `${API_ENDPOINTS.BALLOTING_CATEGORIES}/${id}`;

const useDeleteBallotingCategory = id => {
  const { t } = useTranslation(LOCALIZATION_PAGES.BALLOTING);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, deleteCategory] = useApi(path(id), {
    initialFetch: false,
    verb: HTTP_VERBS.DELETE,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('category_delete_failed'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result || result === '') {
      showNotification({
        message: t('category_delete_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, deleteCategory];
};

export default useDeleteBallotingCategory;
